import { apiCall } from "../../../services/api";
import empty from "is-empty";

import { addError } from "../utils/errors";

import { sa_amend_date } from "../../../utils/saSchema";

function downloadPDF(pdf, name) {
  const blob = new Blob([pdf], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);

  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = name;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  // Clean up if we created an object URL
  if (blob) window.URL.revokeObjectURL(url);
}

export const draft_contract =
  (contractData, project, attachment, goBack) => async (dispatch) => {
    try {
      const res = await apiCall(
        "post",
        `/api/documents/contract`,
        {
          project: project,
          contractData: contractData,
          attachment: attachment,
        },
        {
          responseType: "arraybuffer",
          transformResponse: [
            (data, headers) => {
              const contentType = headers["content-type"];
              if (contentType && contentType.includes("application/json")) {
                const decoder = new TextDecoder("utf-8");
                return JSON.parse(decoder.decode(data));
              }
              return data;
            },
          ],
        }
      );

      const file_name =
        project.PROJECT.NAME + "_" + project.CONSULTANT.last_name;
      downloadPDF(res, file_name);
      goBack();
    } catch (err) {
      dispatch(addError(err.data.error || "Failed to generate contract"));
    }
  };

export const draft_amendment =
  (contractData, project, attachment, goBack) => async (dispatch) => {
    try {
      const res = await apiCall(
        "post",
        `/api/documents/amendment`,
        {
          project: project,
          contractData: contractData,
          attachment: attachment,
        },
        {
          responseType: "arraybuffer",
          transformResponse: [
            (data, headers) => {
              const contentType = headers["content-type"];
              if (contentType && contentType.includes("application/json")) {
                const decoder = new TextDecoder("utf-8");
                return JSON.parse(decoder.decode(data));
              }
              return data;
            },
          ],
        }
      );

      if (!empty(contractData.END_DATE)) {
        try {
          await apiCall(
            "post",
            `/api/springahead/projects/${project.PROJECT_ID}/rate/${project.SPRINGAHEAD_ID}`,
            sa_amend_date({
              END_DATE: contractData.END_DATE,
              CONSULTANT_ID: project.CONSULTANT_ID,
            })
          );
        } catch {
          void 0;
        }
      }

      const file_name =
        "AMENDMENT_" +
        project.PROJECT.NAME +
        "_" +
        project.CONSULTANT.last_name;
      downloadPDF(res, file_name);
      goBack();
    } catch (err) {
      dispatch(addError(err.data.error || "Failed to generate amendment"));
    }
  };

export const get_contract = (envelope_id) => async (dispatch) => {
  try {
    const res = await apiCall(
      "post",
      `/api/documents/download`,
      {
        envelope_id: envelope_id,
      },
      {
        responseType: "arraybuffer",
        transformResponse: [
          (data, headers) => {
            const contentType = headers["content-type"];
            if (contentType && contentType.includes("application/json")) {
              // If it's JSON, parse it
              const decoder = new TextDecoder("utf-8");
              return JSON.parse(decoder.decode(data));
            }
            // If it's not JSON, return the binary data as is
            return data;
          },
        ],
      }
    );

    const file_name = `${envelope_id}.pdf`;
    downloadPDF(res, file_name);
  } catch (err) {
    dispatch(addError(err.data.error || "Failed to download document"));
  }
};
